import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(private title: Title) {}

  updateTitle(title: string) {
    const prev = this.host;
    this.title.setTitle(prev + title);
  }

  setTitle() {
    if (environment.production) {
      this.title.setTitle('my-car');
    } else {
      this.title.setTitle('mycar-india');
    }
  }

  get host() {
    if (environment.production) {
      return 'my-car - ';
    } else {
      return 'mycar-india - ';
    }
  }
}
